import { ReactElement, useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { formatTimeWithSeconds } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, IEventHistory } from "../../../types";
import TableContainer  from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "dateTime",
    label: "Time",
    minWidth: 100,
    align: "center",
    format: value => formatTimeWithSeconds(value)
  },
  {
    id: "stage",
    label: "Steps",
    minWidth: 200,
    align: "center"
  },
  {
    id: "name",
    label: "Event",
    minWidth: 300,
  },
  {
    id: "timeInHeat",
    label: "Time in Heat",
    minWidth: 100,
    align: "right",
  },
  {
    id: "kwh",
    label: "Kwh",
    minWidth: 100,
    align: "right",
  },
  {
    id: "am",
    label: "A/M",
    minWidth: 100,
    align: "center",
  }
];


interface IEventData {
  dateTime: number;
  stage: string | null;
  name: string;
  timeInHeat: number | null;
  kwh: number | null;
  am: string | null;
}

interface IProps {
  data: IEventHistory[];
}

const EventPanel = ({ data }: IProps): ReactElement => {
  const [ rows, setRows ] = useState<IEventData[]>([]);

  useEffect(() => {

    const result: IEventData[] = [];

    data.forEach(r => {

      const timeInHeat = r.variables.find(x => x.name === "TimeInHeat");
      const kwh = r.variables.find(x => x.name === "kwh");
      const am = r.variables.find(x => x.name === "AutoManual");


      result.push({
        dateTime: r.dateTime,
        stage: r.stage,
        name: r.name,
        timeInHeat: timeInHeat ? timeInHeat.value as number : null,
        kwh: kwh ? kwh.value as number : null,
        am: am ? am.value as string : null
      });

    });

    setRows(result);
  }, data);

  // const createSortHandler = (property: keyof IEquipmentLife) => () => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size={"small"} >
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, width: column.minWidth }}>
                  {column.label}
                </TableCell>
              )}
              <TableCell className="table-header"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              return (
                <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`temp-row-${index}`}>
                  {columns.map((column: IColumn) => {
                    const value = row[column.id as keyof IEventData];

                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number" ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                  <TableCell/>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EventPanel;
